import {
  useSearchQueryFilter,
  useSearchTypeFromRoute,
} from '@aibees/elephant/hooks';
import { useMemo } from 'react';
import { filteredDepartmentItemsWithFullValues } from '../feature/search-filters/filters/employee-by-department-filter/utils';

export function useDisplaySearchTable() {
  const { params } = useSearchQueryFilter();
  const type = useSearchTypeFromRoute();

  // TODO remove filter when the page and size issue is resolved
  return useMemo(() => {
    const incompleteDepartmentParams = hasIncompleteDepartmentParams(
      params.employee_by_department
    );
    const incompleteHeadcountGrowthParams = hasIncompleteHeadcountGrowthParams(
      params.headcount_growth
    );
    return (
      !!type &&
      Object.keys(params).filter(
        (k) =>
          k !== 'page' &&
          k !== 'size' &&
          k !== 'type' &&
          k !== 'exact_match' &&
          !(k === 'employee_by_department' && incompleteDepartmentParams) &&
          !(k === 'headcount_growth' && incompleteHeadcountGrowthParams) &&
          !(k === 'latest_active_company_only') &&
          !(k === 'latest_active_job_title_only') &&
          !(k === 'include_people_keywords_sources') &&
          !(k === 'companies_include_keywords_sources') &&
          !(k === 'companies_include_keywords_sources_search_match') &&
          !(k === 'include_people_keywords_sources_search_match')
      ).length > 0
    );
  }, [params, type]);
}

// Lightweight validation functions for performance
function hasIncompleteDepartmentParams(department?: string): boolean {
  if (!department) return false;
  return !filteredDepartmentItemsWithFullValues(department).length;
}

function hasIncompleteHeadcountGrowthParams(headcountGrowth?: string): boolean {
  if (!headcountGrowth) return false;
  return !filteredDepartmentItemsWithFullValues(headcountGrowth, true).length;
}
